module.exports = __webpack_public_path__ + "static/media/Logo.29d4eaf3.png";